(function(){
  const toggle = document.querySelector('[data-muuds-menu-toggle]');
  const panel = document.querySelector('[data-muuds-mobile-panel]');
  if(toggle && panel){
    toggle.addEventListener('click', function(){
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
      document.documentElement.classList.toggle('muuds-menu-open', !isOpen);
    });
    panel.addEventListener('click', function(event){
      if(event.target.closest('a')){
        toggle.setAttribute('aria-expanded','false');
        panel.hidden = true;
        document.documentElement.classList.remove('muuds-menu-open');
      }
    });
  }
  const firstImages = document.querySelectorAll('.muuds-products-grid img, .productListing img');
  firstImages.forEach((img, index) => {
    if(index > 3 && !img.hasAttribute('loading')) img.setAttribute('loading','lazy');
    if(!img.hasAttribute('decoding')) img.setAttribute('decoding','async');
  });
})();

(function(){
  function clampRecommendationSlickHeight(){
    if(!document.body || !document.body.classList.contains('template-product')) return;

    var blocks = document.querySelectorAll('.halo-recommendations-block, [data-recommendations-block]');
    blocks.forEach(function(block){
      var track = block.querySelector('.slick-track');
      var list = block.querySelector('.slick-list');
      if(!track) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll('.slick-slide:not(.slick-cloned) .product, .slick-slide:not(.slick-cloned) .product-item, .product'));
      var maxHeight = 0;

      cards.forEach(function(card){
        var rect = card.getBoundingClientRect();
        if(rect && rect.height > maxHeight) maxHeight = rect.height;
      });

      if(maxHeight > 80){
        var finalHeight = Math.ceil(maxHeight + 6) + 'px';
        track.style.setProperty('height', finalHeight, 'important');
        track.style.setProperty('min-height', '0', 'important');
        track.style.setProperty('padding-bottom', '0', 'important');
        track.style.setProperty('margin-bottom', '0', 'important');
        if(list){
          list.style.setProperty('height', finalHeight, 'important');
          list.style.setProperty('min-height', '0', 'important');
          list.style.setProperty('padding-bottom', '0', 'important');
          list.style.setProperty('margin-bottom', '0', 'important');
        }
      } else {
        track.style.setProperty('height', 'auto', 'important');
        track.style.setProperty('min-height', '0', 'important');
        if(list){
          list.style.setProperty('height', 'auto', 'important');
          list.style.setProperty('min-height', '0', 'important');
        }
      }
    });
  }

  var attempts = 0;
  function scheduleClamp(){
    clampRecommendationSlickHeight();
    if(attempts < 12){
      attempts += 1;
      window.setTimeout(scheduleClamp, 350);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', scheduleClamp);
  } else {
    scheduleClamp();
  }
  window.addEventListener('load', clampRecommendationSlickHeight);
  window.addEventListener('resize', function(){ window.setTimeout(clampRecommendationSlickHeight, 150); });
  document.addEventListener('shopify:section:load', clampRecommendationSlickHeight);
})();

/* MUUDS HOTFIX 20: robust fallback for product share popup */
(function(){
  function getShareRoot(target){
    return target && target.closest ? target.closest('.productView-share.style-2') : null;
  }

  function closeAllSharePopups(){
    document.querySelectorAll('.productView-share.style-2 .share-button__fallback.is-open').forEach(function(panel){
      panel.classList.remove('is-open');
    });
    if(document.body) document.body.classList.remove('modal-share-open');
  }

  document.addEventListener('click', function(event){
    var shareButton = event.target.closest('.productView-share.style-2 .share-button__button');
    if(shareButton){
      var root = getShareRoot(shareButton);
      var panel = root ? root.querySelector('.share-button__fallback') : null;
      if(panel){
        event.preventDefault();
        event.stopPropagation();
        var isOpen = panel.classList.contains('is-open');
        closeAllSharePopups();
        if(!isOpen){
          var input = panel.querySelector('input[data-url]');
          if(input) input.value = input.getAttribute('data-url') || input.value;
          panel.classList.add('is-open');
          document.body.classList.add('modal-share-open');
        }
      }
      return;
    }

    var closeButton = event.target.closest('.productView-share.style-2 .share-button__close');
    if(closeButton){
      event.preventDefault();
      closeAllSharePopups();
      return;
    }

    if(document.body && document.body.classList.contains('modal-share-open')){
      var insidePanel = event.target.closest('.productView-share.style-2 .share-button__fallback');
      var insideButton = event.target.closest('.productView-share.style-2 .share-button__button');
      if(!insidePanel && !insideButton){
        closeAllSharePopups();
      }
    }
  }, true);

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape') closeAllSharePopups();
  });
})();

/* MUUDS HOTFIX 21: portal-based share modal, always above gallery/product layers */
(function(){
  var activePanel = null;
  var shareCounter = 0;

  function ensureOverlay(){
    var overlay = document.querySelector('.muuds-share-overlay');
    if(!overlay){
      overlay = document.createElement('div');
      overlay.className = 'muuds-share-overlay';
      overlay.setAttribute('aria-hidden','true');
      document.body.appendChild(overlay);
      overlay.addEventListener('click', closeShareModal);
    }
    return overlay;
  }

  function findPanelForRoot(root){
    if(!root) return null;
    var id = root.getAttribute('data-muuds-share-id');
    var panel;

    if(id){
      panel = document.querySelector('.share-button__fallback[data-muuds-share-id="' + id + '"]');
      if(panel) return panel;
    }

    panel = root.querySelector('.share-button__fallback');
    if(!panel) return null;

    id = 'muuds-share-' + (++shareCounter);
    root.setAttribute('data-muuds-share-id', id);
    panel.setAttribute('data-muuds-share-id', id);
    panel.classList.add('muuds-share-panel');
    document.body.appendChild(panel);
    return panel;
  }

  function closeShareModal(){
    document.querySelectorAll('.muuds-share-panel.is-open, .productView-share.style-2 .share-button__fallback.is-open').forEach(function(panel){
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden','true');
    });
    var overlay = document.querySelector('.muuds-share-overlay');
    if(overlay){
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden','true');
    }
    if(document.body){
      document.body.classList.remove('modal-share-open','muuds-share-open');
    }
    if(document.documentElement){
      document.documentElement.classList.remove('muuds-share-open');
    }
    activePanel = null;
  }

  function openShareModal(root){
    var panel = findPanelForRoot(root);
    if(!panel) return false;

    var overlay = ensureOverlay();
    var input = panel.querySelector('input[data-url]');
    if(input){
      input.value = input.getAttribute('data-url') || input.value || window.location.href;
    }

    closeShareModal();
    activePanel = panel;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden','false');
    panel.classList.add('is-open','muuds-share-panel');
    panel.setAttribute('aria-hidden','false');
    document.body.classList.add('modal-share-open','muuds-share-open');
    document.documentElement.classList.add('muuds-share-open');

    var close = panel.querySelector('.share-button__close');
    if(close) window.setTimeout(function(){ close.focus({preventScroll:true}); }, 30);
    return true;
  }

  document.addEventListener('click', function(event){
    var shareButton = event.target.closest && event.target.closest('.productView-share.style-2 .share-button__button');
    if(shareButton){
      event.preventDefault();
      event.stopPropagation();
      if(event.stopImmediatePropagation) event.stopImmediatePropagation();
      var root = shareButton.closest('.productView-share.style-2');
      var id = root && root.getAttribute('data-muuds-share-id');
      var existingPanel = id ? document.querySelector('.muuds-share-panel[data-muuds-share-id="' + id + '"]') : null;
      var isOpen = existingPanel && existingPanel.classList.contains('is-open');
      if(isOpen) closeShareModal();
      else openShareModal(root);
      return false;
    }

    var closeButton = event.target.closest && event.target.closest('.muuds-share-panel .share-button__close, .productView-share.style-2 .share-button__close');
    if(closeButton){
      event.preventDefault();
      event.stopPropagation();
      if(event.stopImmediatePropagation) event.stopImmediatePropagation();
      closeShareModal();
      return false;
    }

    if(activePanel && !event.target.closest('.muuds-share-panel')){
      closeShareModal();
    }
  }, true);

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape') closeShareModal();
  });
})();

/* =========================================================
   MUUDS HOTFIX 49 - Functional wishlist page renderer
   Uses the existing localStorage key: wishlistItem. No product route changes.
   ========================================================= */
(function(){
  function getWishlist(){
    try{
      var list = JSON.parse(localStorage.getItem('wishlistItem') || '[]');
      return Array.isArray(list) ? list.filter(Boolean) : [];
    }catch(e){ return []; }
  }
  function setWishlist(list){
    localStorage.setItem('wishlistItem', JSON.stringify(list));
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){ el.textContent = list.length; });
  }
  function unique(list){
    return list.filter(function(item, index){ return list.indexOf(item) === index; });
  }
  function label(count){
    return count === 1 ? '1 продукт' : count + ' продукта';
  }
  function updateShell(root, count){
    var countLabel = root.querySelector('[data-muuds-wishlist-count-label]');
    var clear = root.querySelector('[data-muuds-wishlist-clear]');
    var empty = root.querySelector('[data-muuds-wishlist-empty]');
    var grid = root.querySelector('[data-muuds-wishlist-grid]');
    if(countLabel) countLabel.textContent = label(count);
    if(clear) clear.hidden = count < 1;
    if(empty) empty.hidden = count > 0;
    if(grid) grid.hidden = count < 1;
  }
  function markAdded(root){
    root.querySelectorAll('[data-wishlist]').forEach(function(btn){
      btn.classList.add('wishlist-added');
      var text = btn.querySelector('.text');
      if(text && window.wishlist && window.wishlist.added) text.textContent = window.wishlist.added;
    });
  }
  function renderWishlist(root){
    var grid = root.querySelector('[data-muuds-wishlist-grid]');
    var status = root.querySelector('[data-muuds-wishlist-status]');
    if(!grid) return;
    var handles = unique(getWishlist());
    if(handles.length !== getWishlist().length) setWishlist(handles);
    updateShell(root, handles.length);
    grid.innerHTML = '';
    if(!handles.length){
      root.classList.remove('is-loading');
      if(status) status.textContent = '';
      return;
    }
    root.classList.add('is-loading');
    if(status) status.textContent = 'Зареждане на любими продукти...';
    Promise.all(handles.map(function(handle){
      var url = '/products/' + encodeURIComponent(handle) + '?view=ajax_wishlist_card';
      return fetch(url, {credentials:'same-origin'})
        .then(function(response){ return response.ok ? response.text() : ''; })
        .then(function(html){ return {handle:handle, html:html}; })
        .catch(function(){ return {handle:handle, html:''}; });
    })).then(function(results){
      var validHandles = [];
      results.forEach(function(result){
        if(result.html && result.html.trim()){
          var wrapper = document.createElement('div');
          wrapper.innerHTML = result.html.trim();
          Array.prototype.slice.call(wrapper.children).forEach(function(child){ grid.appendChild(child); });
          validHandles.push(result.handle);
        }
      });
      if(validHandles.length !== handles.length) setWishlist(validHandles);
      markAdded(grid);
      updateShell(root, validHandles.length);
      grid.classList.add('is-loaded');
      root.classList.remove('is-loading');
      if(status) status.textContent = '';
      document.dispatchEvent(new CustomEvent('muudswishlistloaded', {bubbles:true}));
    });
  }
  function initWishlistPage(){
    document.querySelectorAll('[data-muuds-wishlist-page]').forEach(function(root){
      if(root.dataset.muudsWishlistReady === 'true') return;
      root.dataset.muudsWishlistReady = 'true';
      renderWishlist(root);
      var clear = root.querySelector('[data-muuds-wishlist-clear]');
      if(clear){
        clear.addEventListener('click', function(){
          setWishlist([]);
          renderWishlist(root);
        });
      }
      root.addEventListener('click', function(event){
        var btn = event.target.closest && event.target.closest('[data-wishlist]');
        if(!btn) return;
        window.setTimeout(function(){
          var handles = unique(getWishlist());
          setWishlist(handles);
          updateShell(root, handles.length);
          if(handles.length < 1) renderWishlist(root);
        }, 220);
      });
      window.addEventListener('storage', function(event){
        if(event.key === 'wishlistItem') renderWishlist(root);
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initWishlistPage);
  else initWishlistPage();
})();

/* MUUDS HOTFIX 51 — reset Slick dimensions on product mobile gallery */
(function(){
  function refreshProductGallery(){
    if(!document.body || !document.body.classList.contains('template-product')) return;
    if(window.innerWidth > 991) return;
    var galleries = document.querySelectorAll('.productView-nav, .productView-for, .productView-thumbnail');
    galleries.forEach(function(el){
      try{
        if(window.jQuery && window.jQuery(el).hasClass('slick-initialized')){
          window.jQuery(el).slick('setPosition');
        }
      }catch(e){}
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshProductGallery);
  else refreshProductGallery();
  window.addEventListener('load', function(){ setTimeout(refreshProductGallery, 80); setTimeout(refreshProductGallery, 450); });
  window.addEventListener('resize', function(){ clearTimeout(window.__muudsGalleryResize); window.__muudsGalleryResize = setTimeout(refreshProductGallery, 140); });
})();

/* MUUDS HOTFIX 52 — mobile thumbnail wrapper height cleanup */
(function(){
  function cleanMobileProductThumbs(){
    if(!document.body || !document.body.classList.contains('template-product')) return;
    if(window.innerWidth > 767) return;

    document.querySelectorAll('.productView-thumbnail-wrapper, .productView-for, .productView-for .slick-list, .productView-for .slick-track').forEach(function(el){
      el.style.maxHeight = '';
      el.style.overflowY = '';
      el.style.top = '';
      el.style.left = '';
      el.style.right = '';
    });

    document.querySelectorAll('.productView-for.slick-initialized').forEach(function(el){
      try{
        if(window.jQuery){ window.jQuery(el).slick('setPosition'); }
      }catch(e){}
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanMobileProductThumbs);
  else cleanMobileProductThumbs();
  window.addEventListener('load', function(){ setTimeout(cleanMobileProductThumbs, 120); setTimeout(cleanMobileProductThumbs, 600); });
  window.addEventListener('resize', function(){ clearTimeout(window.__muudsThumbClean); window.__muudsThumbClean = setTimeout(cleanMobileProductThumbs, 180); });
})();

/* HOTFIX 53: keep mobile product thumbnails visible and stop slick drift */
(function(){
  function fixMobileProductThumbs(){
    if (!document.body || !document.body.classList.contains('template-product')) return;
    if (window.innerWidth > 767) return;

    document.querySelectorAll('.productView-thumbnail-wrapper .slick-track, .productView-for .slick-track').forEach(function(track){
      track.style.setProperty('transform', 'translate3d(0px, 0px, 0px)', 'important');
      track.style.setProperty('left', '0px', 'important');
      track.style.setProperty('height', window.innerWidth <= 380 ? '88px' : '96px', 'important');
      track.style.setProperty('display', 'flex', 'important');
    });

    document.querySelectorAll('.productView-thumbnail-wrapper .slick-list, .productView-for .slick-list').forEach(function(list){
      list.style.setProperty('overflow-x', 'auto', 'important');
      list.style.setProperty('overflow-y', 'hidden', 'important');
      list.style.setProperty('height', window.innerWidth <= 380 ? '88px' : '96px', 'important');
      list.style.setProperty('max-height', window.innerWidth <= 380 ? '88px' : '96px', 'important');
    });
  }

  document.addEventListener('DOMContentLoaded', fixMobileProductThumbs);
  window.addEventListener('load', fixMobileProductThumbs);
  window.addEventListener('resize', fixMobileProductThumbs);
  document.addEventListener('shopify:section:load', fixMobileProductThumbs);
  setTimeout(fixMobileProductThumbs, 400);
  setTimeout(fixMobileProductThumbs, 1200);
})();

/* MUUDS HOTFIX 57 - remove accidental inner mobile scrollbars */
(function(){
  function muudsFixMobileInnerScroll(){
    if (window.innerWidth > 767) return;

    var allowInside = [
      '.halo-sidebar', '.halo-popup', '.halo-modal', '.modal', '.popup',
      '.menu-drawer', '.mobileMenu-toggle', '#halo-cart-sidebar', '.cart-sidebar',
      '#halo-search-popup', '.predictive-search', '.quickSearchResultsWrap',
      '.drawer', '[role="dialog"]'
    ];

    var targets = document.querySelectorAll(
      '.body-content-wrapper, .wrapper-body, #MainContent, .content-for-layout, .page, ' +
      '.wrapper-footer, .shopify-section-group-footer-group, footer, .footer, ' +
      '.footer.footer-1, .footer.footer-1 .footer__content-top, .footer.footer-1 .footer__content-bottom, ' +
      '.footer.footer-1 .container, .footer.footer-1 .halo-row, .footer.footer-1 .footer-block__item, ' +
      '.footer.footer-1 .footer-block, .footer.footer-1 .footer-block__details, .footer.footer-1 .footer-block__list, ' +
      '.footer.footer-1 .footer-block__newsletter'
    );

    targets.forEach(function(el){
      if (!el || el === document.body || el === document.documentElement) return;

      for (var i = 0; i < allowInside.length; i++) {
        if (el.closest && el.closest(allowInside[i])) return;
      }

      el.style.height = 'auto';
      el.style.minHeight = '0';
      el.style.maxHeight = 'none';
      el.style.overflowY = 'visible';
      el.style.overflowX = 'clip';
      el.style.webkitOverflowScrolling = 'auto';
    });
  }

  document.addEventListener('DOMContentLoaded', muudsFixMobileInnerScroll);
  window.addEventListener('load', muudsFixMobileInnerScroll);
  window.addEventListener('resize', function(){
    window.clearTimeout(window.__muudsMobileScrollFixTimer);
    window.__muudsMobileScrollFixTimer = window.setTimeout(muudsFixMobileInnerScroll, 120);
  });
  document.addEventListener('shopify:section:load', muudsFixMobileInnerScroll);
})();

/* MUUDS HOTFIX 59: predictive product suggestions by product name and SKU */
(function(){
  function debounce(fn, wait){
    var timeout;
    return function(){
      var ctx = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function(){ fn.apply(ctx, args); }, wait);
    };
  }

  function escapeHtml(value){
    return String(value || '').replace(/[&<>"]/g, function(ch){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]);
    });
  }

  function formatMoneyFallback(product){
    if(product.price){ return escapeHtml(product.price); }
    if(product.price_min){ return escapeHtml(product.price_min); }
    return '';
  }

  function getProductImage(product){
    if(product.image){ return product.image; }
    if(product.featured_image && product.featured_image.url){ return product.featured_image.url; }
    if(product.featured_image){ return product.featured_image; }
    return '';
  }

  function getMatchingSku(product, query){
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    var normalizedQuery = String(query || '').trim().toLowerCase();
    if(!normalizedQuery) return '';
    for(var i = 0; i < variants.length; i++){
      var sku = String((variants[i] || {}).sku || '').trim();
      if(sku && sku.toLowerCase().indexOf(normalizedQuery) !== -1){
        return sku;
      }
    }
    return '';
  }

  function renderSuggestions(form, products, query){
    var box = form.querySelector('[data-muuds-search-suggestions]');
    if(!box) return;

    if(!query || query.length < 2){
      box.hidden = true;
      box.innerHTML = '';
      return;
    }

    if(!products || !products.length){
      box.innerHTML = '<div class="muuds-search-suggestions__empty">Няма намерени продукти.</div><a class="muuds-search-suggestions__all" href="/search?type=product&q=' + encodeURIComponent(query) + '">Виж всички резултати</a>';
      box.hidden = false;
      return;
    }

    var items = products.slice(0, 6).map(function(product){
      var url = product.url || ('/search?type=product&q=' + encodeURIComponent(query));
      var img = getProductImage(product);
      var price = formatMoneyFallback(product);
      var matchingSku = getMatchingSku(product, query);
      return '<li class="muuds-search-suggestions__item">' +
        '<a class="muuds-search-suggestions__link" href="' + escapeHtml(url) + '">' +
          '<span class="muuds-search-suggestions__image">' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" decoding="async">' : '<span class="muuds-search-suggestions__fallback-img">♡</span>') +
          '</span>' +
          '<span class="muuds-search-suggestions__content">' +
            '<span class="muuds-search-suggestions__title">' + escapeHtml(product.title) + '</span>' +
            (matchingSku ? '<span class="muuds-search-suggestions__sku">SKU: ' + escapeHtml(matchingSku) + '</span>' : '') +
            (price ? '<span class="muuds-search-suggestions__price">' + price + '</span>' : '') +
          '</span>' +
        '</a>' +
      '</li>';
    }).join('');

    box.innerHTML = '<ul class="muuds-search-suggestions__list">' + items + '</ul><a class="muuds-search-suggestions__all" href="/search?type=product&q=' + encodeURIComponent(query) + '">Виж всички резултати</a>';
    box.hidden = false;
  }

  function fetchSuggestions(form, query){
    var box = form.querySelector('[data-muuds-search-suggestions]');
    if(!box) return;
    query = (query || '').trim();
    if(query.length < 2){
      renderSuggestions(form, [], query);
      return;
    }

    box.innerHTML = '<div class="muuds-search-suggestions__loading">Търсим продукти...</div>';
    box.hidden = false;

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';
    fetch(url, { credentials: 'same-origin' })
      .then(function(response){ return response.ok ? response.json() : Promise.reject(response); })
      .then(function(data){
        var products = (((data || {}).resources || {}).results || {}).products || [];
        renderSuggestions(form, products, query);
      })
      .catch(function(){
        box.innerHTML = '<div class="muuds-search-suggestions__empty">Не успяхме да заредим предложенията.</div><a class="muuds-search-suggestions__all" href="/search?type=product&q=' + encodeURIComponent(query) + '">Търси в сайта</a>';
        box.hidden = false;
      });
  }

  function initMuudsPredictiveSearch(){
    document.querySelectorAll('[data-muuds-predictive-search]').forEach(function(form){
      if(form.dataset.muudsPredictiveReady === 'true') return;
      form.dataset.muudsPredictiveReady = 'true';
      var input = form.querySelector('[data-muuds-search-input], input[type="search"]');
      var box = form.querySelector('[data-muuds-search-suggestions]');
      if(!input || !box) return;

      var run = debounce(function(){ fetchSuggestions(form, input.value); }, 180);
      input.addEventListener('input', run);
      input.addEventListener('focus', function(){
        if(input.value.trim().length >= 2) fetchSuggestions(form, input.value);
      });
      input.addEventListener('keydown', function(event){
        if(event.key === 'Escape'){
          box.hidden = true;
          box.innerHTML = '';
          input.blur();
        }
      });
      form.addEventListener('submit', function(){
        box.hidden = true;
      });
    });
  }

  document.addEventListener('click', function(event){
    document.querySelectorAll('[data-muuds-predictive-search]').forEach(function(form){
      if(!form.contains(event.target)){
        var box = form.querySelector('[data-muuds-search-suggestions]');
        if(box) box.hidden = true;
      }
    });
  });

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initMuudsPredictiveSearch);
  } else {
    initMuudsPredictiveSearch();
  }
  document.addEventListener('shopify:section:load', initMuudsPredictiveSearch);
})();

/* MUUDS hotfix 68: full-screen mobile curtain close controls */
(function(){
  function closeMenu(){
    var toggle = document.querySelector('[data-muuds-menu-toggle]');
    var panel = document.querySelector('[data-muuds-mobile-panel]');
    if(toggle) toggle.setAttribute('aria-expanded', 'false');
    if(panel) panel.hidden = true;
    document.documentElement.classList.remove('muuds-menu-open');
  }

  document.addEventListener('click', function(event){
    var closeBtn = event.target.closest && event.target.closest('[data-muuds-mobile-close]');
    if(closeBtn){
      event.preventDefault();
      closeMenu();
    }
  });

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape' && document.documentElement.classList.contains('muuds-menu-open')){
      closeMenu();
    }
  });

  window.addEventListener('resize', function(){
    if(window.innerWidth > 990 && document.documentElement.classList.contains('muuds-menu-open')){
      closeMenu();
    }
  });
})();

/* MUUDS hotfix 69: active state fallback for desktop/mobile menu links */
(function(){
  function normalizePath(url){
    try{
      var parsed = new URL(url, window.location.origin);
      var path = parsed.pathname.replace(/\/+$/, '');
      return path || '/';
    }catch(e){
      return '';
    }
  }

  function markActiveMenu(){
    var header = document.querySelector('[data-muuds-header]');
    if(!header) return;
    var current = normalizePath(window.location.href);
    if(!current) return;

    header.querySelectorAll('.muuds-nav__link, .muuds-mega__card, .muuds-mobile-menu a, .muuds-mobile-submenu a').forEach(function(link){
      var href = link.getAttribute('href');
      if(!href || href === '#') return;
      if(normalizePath(href) === current){
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'page');
        if(link.classList.contains('muuds-nav__link')){
          var navItem = link.closest('.muuds-nav__item');
          if(navItem) navItem.classList.add('is-active');
        }
        if(link.parentElement && link.parentElement.matches('.muuds-mobile-menu > li')){
          link.parentElement.classList.add('is-active');
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', markActiveMenu);
  document.addEventListener('shopify:section:load', markActiveMenu);
})();


/* MUUDS HOTFIX 71: exact active state only + cleaner desktop active style */
(function(){
  function normalizePath(url){
    try{
      var parsed = new URL(url, window.location.origin);
      var path = parsed.pathname.replace(/\/+$/, '');
      return path || '/';
    }catch(e){
      return '';
    }
  }

  function fixExactMenuActive(){
    var header = document.querySelector('[data-muuds-header]');
    if(!header) return;
    var current = normalizePath(window.location.href);
    if(!current) return;

    header.querySelectorAll('.muuds-nav__item').forEach(function(item){
      var topLink = item.querySelector(':scope > .muuds-nav__link');
      if(!topLink) return;
      var isExact = normalizePath(topLink.getAttribute('href')) === current;
      if(!isExact){
        item.classList.remove('is-active');
        topLink.classList.remove('is-active');
        if(topLink.getAttribute('aria-current') === 'page') topLink.removeAttribute('aria-current');
      }
    });

    header.querySelectorAll('.muuds-mobile-menu > li').forEach(function(item){
      var topLink = item.querySelector(':scope > a');
      if(!topLink) return;
      var isExact = normalizePath(topLink.getAttribute('href')) === current;
      if(!isExact){
        item.classList.remove('is-active');
        topLink.classList.remove('is-active');
        if(topLink.getAttribute('aria-current') === 'page') topLink.removeAttribute('aria-current');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', fixExactMenuActive);
  document.addEventListener('shopify:section:load', fixExactMenuActive);
  setTimeout(fixExactMenuActive, 80);
})();

/* MUUDS HOTFIX 82: remove countdown on empty cart after dynamic cart updates */
(function(){
  function syncCartCountdown(){
    try{
      var countdowns = document.querySelectorAll('.cart-countdown');
      if(!countdowns.length) return;
      var hasCartItem = !!document.querySelector('[data-cart-content] .cart-item, #main-cart-items .cart-item, .cart-list .cart-item');
      var emptyText = document.querySelector('.cart-empty, .cart__empty-text, [data-cart-empty], .empty-cart, .cart-content-empty');
      countdowns.forEach(function(el){
        if(!hasCartItem || emptyText){
          el.classList.add('muuds-cart-countdown-empty');
          el.style.display = 'none';
        }
      });
    }catch(e){}
  }
  document.addEventListener('DOMContentLoaded', syncCartCountdown);
  document.addEventListener('cart:updated', syncCartCountdown);
  document.addEventListener('ajaxCart.afterCartLoad', syncCartCountdown);
  document.addEventListener('shopify:section:load', syncCartCountdown);
  setTimeout(syncCartCountdown, 400);
})();


/* MUUDS HOTFIX 83: remove cart edit buttons and hide empty discount text after ajax updates */
(function(){
  function cleanCartExtras(){
    try{
      document.querySelectorAll('.cart-item-edit, .previewCartItem-edit, [data-open-edit-cart]').forEach(function(el){
        var inCart = el.closest('body.template-cart, .halo-cart-sidebar, .previewCart, .cart-container, .halo-cart-content');
        if(inCart){
          el.remove();
        }
      });
      document.querySelectorAll('body.template-cart .discount-code-field .form-text, body.template-cart .cart-coupon-code .form-text, .halo-cart-sidebar .discount-code-field .form-text, .halo-cart-sidebar .cart-coupon-code .form-text').forEach(function(el){
        el.remove();
      });
      document.querySelectorAll('[data-saved-discount-display]').forEach(function(el){
        var raw = el.getAttribute('data-dis');
        var value = raw == null ? 0 : parseFloat(String(raw).replace(',', '.'));
        var text = (el.textContent || '').replace(/\s+/g,' ').trim();
        if(!value || value <= 0 || text === '-' || text === '-0' || text === '-0.00' || /^Отстъпка\s*-0([,.]00)?(\s*\S+)?$/.test(text)){
          el.style.display = 'none';
          el.classList.add('muuds-no-discount');
        }
      });
    }catch(e){}
  }
  document.addEventListener('DOMContentLoaded', cleanCartExtras);
  document.addEventListener('cart:updated', cleanCartExtras);
  document.addEventListener('ajaxCart.afterCartLoad', cleanCartExtras);
  document.addEventListener('shopify:section:load', cleanCartExtras);
  setTimeout(cleanCartExtras, 250);
  setTimeout(cleanCartExtras, 900);
})();

/* MUUDS HOTFIX 85: compact cart discount apply with invalid-code feedback */
(function(){
  function getRoot(){
    return (window.routes && window.routes.root) ? window.routes.root.replace(/\/$/, '') : '';
  }
  function normalizeCode(code){
    return String(code || '').trim().toLowerCase();
  }
  function discountCheckPath(code){
    var root = getRoot();
    var base = (root || '') + '/cart';
    var join = base.indexOf('?') === -1 ? '?' : '&';
    return base + join + 'muuds_discount_check=' + encodeURIComponent(code);
  }
  function buildDiscountUrl(code){
    var root = getRoot();
    return (root || '') + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(discountCheckPath(code));
  }
  function getWrap(el){
    return el ? el.closest('.cart-coupon-code, .discount-code-field, .cart-total-coupon') : null;
  }
  function ensureMessage(wrap){
    if(!wrap) return null;
    var holder = wrap.querySelector('.muuds-cart-discount-message');
    if(!holder){
      holder = document.createElement('div');
      holder.className = 'muuds-cart-discount-message';
      holder.setAttribute('role', 'status');
      holder.setAttribute('aria-live', 'polite');
      wrap.appendChild(holder);
    }
    return holder;
  }
  function showMessage(wrap, text, type){
    var msg = ensureMessage(wrap);
    if(!msg) return;
    msg.textContent = text || '';
    msg.classList.remove('is-error', 'is-success', 'is-empty');
    if(!text){
      msg.classList.add('is-empty');
      return;
    }
    msg.classList.add(type === 'success' ? 'is-success' : 'is-error');
  }
  function setLoading(button, loading){
    if(!button) return;
    if(loading){
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      button.dataset.originalText = button.dataset.originalText || button.textContent || 'Приложи';
      button.textContent = 'Прилага се';
    }else{
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      if(button.dataset.originalText) button.textContent = button.dataset.originalText;
    }
  }
  function applyDiscount(input, button){
    if(!input) return;
    var code = (input.value || '').trim();
    var wrap = getWrap(input) || getWrap(button);
    if(!code){
      showMessage(wrap, 'Моля, въведете код за отстъпка.', 'error');
      input.focus();
      return;
    }
    try{
      localStorage.setItem('storedDiscount', code);
      localStorage.setItem('muudsPendingDiscountCode', code);
    }catch(e){}
    showMessage(wrap, '', '');
    setLoading(button, true);
    window.location.href = buildDiscountUrl(code);
  }
  function hasAppliedCode(cart, code){
    var target = normalizeCode(code);
    if(!target || !cart) return false;
    var found = false;
    function checkTitle(value){
      if(normalizeCode(value) === target) found = true;
    }
    (cart.cart_level_discount_applications || []).forEach(function(app){
      checkTitle(app.title || app.code || app.name);
    });
    (cart.items || []).forEach(function(item){
      (item.discount_allocations || []).forEach(function(app){
        if(app.discount_application){ checkTitle(app.discount_application.title || app.discount_application.code || app.discount_application.name); }
      });
      (item.line_level_discount_allocations || []).forEach(function(app){
        if(app.discount_application){ checkTitle(app.discount_application.title || app.discount_application.code || app.discount_application.name); }
      });
      (item.discounts || []).forEach(function(discount){
        checkTitle(discount.title || discount.code || discount.name);
      });
    });
    return found;
  }
  function checkPendingDiscount(){
    if(!document.body.classList.contains('template-cart')) return;
    var params = new URLSearchParams(window.location.search || '');
    var code = params.get('muuds_discount_check');
    if(!code){
      try{ code = localStorage.getItem('muudsPendingDiscountCode') || ''; }catch(e){}
    }
    if(!code) return;
    var input = document.querySelector('body.template-cart .cart-coupon-code input[name="discount"], body.template-cart #cart-coupon-code');
    if(input && !input.value) input.value = code;
    var wrap = getWrap(input) || document.querySelector('body.template-cart .cart-coupon-code, body.template-cart .discount-code-field');
    fetch((getRoot() || '') + '/cart.js', { credentials: 'same-origin' })
      .then(function(res){ return res.ok ? res.json() : null; })
      .then(function(cart){
        if(hasAppliedCode(cart, code)){
          showMessage(wrap, 'Кодът е приложен успешно.', 'success');
          try{ localStorage.removeItem('muudsPendingDiscountCode'); }catch(e){}
        }else{
          showMessage(wrap, 'Кодът не е валиден или не може да бъде приложен към тази количка.', 'error');
          try{ localStorage.removeItem('muudsPendingDiscountCode'); }catch(e){}
        }
      })
      .catch(function(){
        showMessage(wrap, 'Не успяхме да проверим кода. Моля, опитайте отново.', 'error');
      });
  }
  function initCartDiscountApply(){
    try{
      document.querySelectorAll('body.template-cart .cart-coupon-code input[name="discount"], body.template-cart #cart-coupon-code').forEach(function(input){
        if(!input.value){
          try{
            var stored = localStorage.getItem('storedDiscount');
            if(stored) input.value = stored;
          }catch(e){}
        }
        var wrap = getWrap(input);
        ensureMessage(wrap);
        if(input.dataset.muudsDiscountReady === 'true') return;
        input.dataset.muudsDiscountReady = 'true';
        input.addEventListener('input', function(){
          showMessage(getWrap(input), '', '');
        });
        input.addEventListener('keydown', function(event){
          if(event.key === 'Enter'){
            event.preventDefault();
            var wrap = getWrap(input);
            applyDiscount(input, wrap ? wrap.querySelector('[data-muuds-cart-discount-apply]') : null);
          }
        });
      });
      document.querySelectorAll('body.template-cart [data-muuds-cart-discount-apply]').forEach(function(button){
        if(button.dataset.muudsDiscountButtonReady === 'true') return;
        button.dataset.muudsDiscountButtonReady = 'true';
        button.addEventListener('click', function(event){
          event.preventDefault();
          var wrap = getWrap(button);
          var input = wrap ? wrap.querySelector('input[name="discount"], #cart-coupon-code') : document.querySelector('body.template-cart #cart-coupon-code');
          applyDiscount(input, button);
        });
      });
      var checkout = document.getElementById('cart-checkout');
      if(checkout && checkout.dataset.muudsCheckoutDiscountReady !== 'true'){
        checkout.dataset.muudsCheckoutDiscountReady = 'true';
        checkout.addEventListener('click', function(){
          var input = document.querySelector('body.template-cart .cart-coupon-code input[name="discount"], body.template-cart #cart-coupon-code');
          var code = input && input.value ? input.value.trim() : '';
          if(code){
            try{ localStorage.setItem('storedDiscount', code); }catch(e){}
            var href = checkout.getAttribute('data-href') || checkout.getAttribute('href') || '/checkout';
            var separator = href.indexOf('?') === -1 ? '?' : '&';
            if(href.indexOf('discount=') === -1){
              checkout.setAttribute('data-href', href + separator + 'discount=' + encodeURIComponent(code));
            }
          }
        }, true);
      }
    }catch(e){}
  }
  document.addEventListener('DOMContentLoaded', function(){ initCartDiscountApply(); setTimeout(checkPendingDiscount, 180); });
  document.addEventListener('cart:updated', initCartDiscountApply);
  document.addEventListener('ajaxCart.afterCartLoad', initCartDiscountApply);
  document.addEventListener('shopify:section:load', initCartDiscountApply);
  setTimeout(initCartDiscountApply, 300);
  setTimeout(initCartDiscountApply, 1000);
})();

/* MUUDSFASHION HOTFIX 102: keep mobile product gallery counter inside the main image */
(function(){
  function isProductMobile(){
    return document.body && document.body.classList.contains('template-product') && window.innerWidth < 768;
  }

  function normalizeCounters(nav){
    if(!nav) return;
    var list = nav.querySelector('.slick-list');
    if(!list) return;
    var counters = Array.prototype.slice.call(nav.querySelectorAll('.slick-counter'));
    if(!counters.length) return;

    var keep = counters[0];
    counters.slice(1).forEach(function(counter){
      if(counter !== keep) counter.remove();
    });

    if(keep.parentElement !== list){
      list.appendChild(keep);
    }
  }

  function fixProductGalleryCounter(){
    if(!isProductMobile()) return;
    document.querySelectorAll('body.template-product .productView-nav').forEach(normalizeCounters);
  }

  function scheduleFix(){
    if(!isProductMobile()) return;
    fixProductGalleryCounter();
    setTimeout(fixProductGalleryCounter, 80);
    setTimeout(fixProductGalleryCounter, 250);
    setTimeout(fixProductGalleryCounter, 700);
    setTimeout(fixProductGalleryCounter, 1200);
  }

  document.addEventListener('DOMContentLoaded', scheduleFix);
  document.addEventListener('shopify:section:load', scheduleFix);
  window.addEventListener('resize', scheduleFix, { passive:true });

  if(document.body && document.body.classList.contains('template-product')){
    try{
      var observer = new MutationObserver(function(){ scheduleFix(); });
      observer.observe(document.body, { childList:true, subtree:true });
    }catch(e){}
  }

  scheduleFix();
})();
